/* global $ */
(function (angular) {
    'use strict';

    angular.module('app')
        .controller('sendConnectRequestController', sendConnectRequestController);

    sendConnectRequestController.$inject = [
        '$uibModalInstance',
        '$scope',
        'userId',
        'UsersApi',
        'ConnectRequestsApi',
        'alerts'
    ];

    function sendConnectRequestController(
        $uibModalInstance,
        $scope,
        userId,
        UsersApi,
        ConnectRequestsApi,
        alerts
    ) {
        var vm = this;

        // properties
        vm.user = null;
        vm.isLoading = false;
        vm.connectRequest = {
            user_id: userId,
            message: '',
        };

        // methods
        vm.close = $uibModalInstance.close;
        vm.send = send;

        /**
         * Gets the user to send the request to, and adds to scope
         * @return {void}
         */
        function getUser() {
            vm.isLoading = true;
            vm.isLoadingMessage = 'Loading...';
            UsersApi.get({id: userId}, function (user) {
                vm.user = user.data;
                vm.isLoading = false;
                $('#connect-message').focus();
            }, function () {
                vm.forceClose = true;
                $uibModalInstance.dismiss();
            });
        }

        /**
         * Sends the connection request to the API
         * @return {void}
         */
        function send() {
            vm.isLoadingMessage = 'Sending request...';
            vm.isLoading = true;
            ConnectRequestsApi.save(vm.connectRequest, function handleConnectResponse(response) {
                vm.isLoading = false;
                alerts.emit({
                    theme: 'success',
                    title: 'Request Sent',
                    messages: ['A connect request has been sent to ' + vm.user.forename]
                });
                $uibModalInstance.close(response);
            }, function handleConnectError() {
                vm.isLoading = false;
                vm.forceClose = true;
                $uibModalInstance.dismiss();
            });
        }

        $scope.$on('modal.closing', function (event, reason, closed) {
            if (!closed && !vm.forceClose) {
                return event.preventDefault();
            }
        });

        getUser();
    }

}(angular));
